import { useTheme } from '@emotion/react';
import { AppBar, Box, Toolbar } from '@mui/material';
import { iconBtnContainerSx, padding0MarginRight16Sx } from './NavBar.style';
import { Heading } from '../Heading/Heading';
import { Post } from '../../icons/Post/Post';
import { AddVideo } from '../../icons/AddVideo/AddVideo';
import { IconBtn } from '../IconBtn/IconBtn';
import { useNavigate } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';
import { Burger } from '../../icons/Burger/Burger';
import { useState } from 'react';
import { NavDrawer } from '../NavDrawer/NavDrawer';
import { appBarSx, toolbarSx } from '../../styles/Global.style';
import { brandOverride } from '../../clients/brandOverride';

export const NavBar = ({ title, logo, isSignedIn }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const color = theme.palette.secondary.main;
  const isPost = location.pathname === APP_PATHS.post;
  const isVideos = location.pathname === APP_PATHS.videos;
  const isAddVideo = location.pathname === APP_PATHS.addVideo;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const brandLogo = brandOverride().logo;

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  return (
    <AppBar position="sticky" sx={appBarSx(theme)}>
      <Toolbar sx={toolbarSx} disableGutters>
        {title ? (
          <>
            {logo && logo}
            <Heading text={title} level={1} />
          </>
        ) : (
          <IconBtn
            icon={brandLogo}
            onClick={() => navigate(APP_PATHS.home)}
            color={color}
            aria="Logo button"
            sx={padding0MarginRight16Sx}
          />
        )}

        <Box sx={iconBtnContainerSx}>
          {isSignedIn && (
            <>
              {!isPost && !isVideos && !isAddVideo && (
                <IconBtn
                  icon={<Post />}
                  onClick={() => navigate(APP_PATHS.post)}
                  color={color}
                  aria="Add post button"
                  sx={padding0MarginRight16Sx}
                />
              )}

              {isVideos && (
                <IconBtn
                  icon={<AddVideo />}
                  onClick={() => navigate(APP_PATHS.addVideo)}
                  color={color}
                  aria="Add video button"
                  sx={padding0MarginRight16Sx}
                />
              )}

              <IconBtn
                icon={<Burger />}
                onClick={() => setIsDrawerOpen(true)}
                color={color}
                aria="Menu button"
                sx={{ padding: '4px 0px 0px' }}
              />
            </>
          )}
        </Box>

        <NavDrawer
          toggleDrawer={toggleDrawer}
          isSignedIn={isSignedIn}
          isDrawerOpen={isDrawerOpen}
        />
      </Toolbar>
    </AppBar>
  );
};
